import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  inputs: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  itemtext: { paddingLeft: UNIT * 0.3125 },
  listItem: { width: UNIT * 13.75 },
  title: {
    fontSize: UNIT * 1.25,
    padding: UNIT * 0.3125,
    color: 'gray'
  },
  pos: {
    display: 'inline-block',
    fontSize: UNIT * 0.75,
    color: 'grey'
  },
  icon: {
    maginLeft: UNIT * 1.25,
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`
  },
  textField: {
    marginLeft: UNIT * 0.5,
    marginRight: UNIT * 0.5,
    display: 'flex',
    justifyContent: 'space-between'
  },
  feeStyle: {
    marginTop: 'auto',
    marginBottom: 'auto',
    fontSize: UNIT * 0.9325,
    padding: '0 10px 0 10px',
    width: '100%',
    paddingTop: UNIT * 1.125
  },
  inputStyle: { width: '100%', padding: '14px 10px 0 10px' },
  contentStyle: { padding: UNIT, backgroundColor: '#80808014' },
  contactStyle: { paddingRight: UNIT * 1.25, marginTop: 0 },
  separator: {
    display: 'flex',
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    height: 1,
    marginTop: UNIT,
    marginBottom: UNIT,
    marginLeft: UNIT * 0.625,
    marginRight: UNIT * 0.625
  },
  labelStyle: {
    fontSize: UNIT * 0.875
  },
  removeIcon: {
    width: UNIT,
    height: UNIT,
    fontSize: UNIT * 0.9375,
    alignSelf: 'center',

    color: mainColor.colorWhite
  },
  slotLabel: {
    color: `rgba(${mainColor.rgb}, 0.8)`,
    marginLeft: UNIT * 0.625,
    fontSize: UNIT,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  textStyle: { fontSize: UNIT, marginLeft: UNIT * 0.625, marginRight: UNIT * 0.625 },
  itemHeader: {
    display: 'flex',

    flexDirection: 'row',
    padding: UNIT * 1.25
  },
  dayLabel: {
    fontSize: UNIT
  },
  limitLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: UNIT
  },
  limitInput: {
    width: UNIT * 3,
    marginLeft: UNIT * 0.5,
    marginRight: UNIT * 0.5
  },
  paperStyle: {
    marginTop: UNIT,
    boxShadow: `1px 3px 5px #ccc`
  },
  errorMessage: {
    color: 'red',
    fontSize: UNIT * 0.75,
    marginTop: UNIT * 0.3125,
    marginLeft: -UNIT *0.4375
  },
  errorInput: {
    color: 'red!important'
  },
  boldText: {
    fontSize: UNIT,
    fontWeight: 'bolder'
  },
  headerFee: {
    fontWeight: 'normal',
    fontSize: UNIT * 0.6875,
    color: mainColor.colorBlack
  },
});
